<section class="page-wrap animated fadeIn">
  <header class="pattern-header">
    Our Guiding Principles
  </header>

  <div class="padding-section">

    <p class="h6-regular">
      At Carlton Farms, we humanely and organically use domestic animals to produce the nutritious food we provide for
      our growing population. We do not endorse subjecting our animals to highly confined unnatural conditions to
      increase production. We would instead allow our animals to roam our pastures and exhibit their natural,
      instinctual behavior. In other words:
    </p>

    <p class="h6-bold fst-italic">
      “We want our cows to be able to graze clean, organically managed pastures and lay in the shade to chew their cud;
      our pigs to root in the dirt and wallow in the mud; and our chickens to be provided protection from weather and
      predators while still being able to range our pastures, eating forage and bugs.”
    </p>

    <p class="h6-regular">
      This environment that we provide for them not only makes for happy animals (which I’m sure it does) but also
      creates a stress-free lifestyle and allows for a natural, balanced diet for each animal.
    </p>

  </div>

  <div class="padding-section pattern grid-section">

    <img class="image" loading="lazy" src="/assets/images/landing/about/our-guiding-principles/grass-based.webp"
      alt="Cows grazing in a green pasture under a clear blue sky, with a wooden fence in the background.">

    <div>
      <h3 class="title">
        Grass Based
      </h3>
      <p class="description">
        All of our animals live in a system that provides continuous access to organically managed grass pastures.
      </p>
      <p class="description">
        We believe grass is the primary key to producing healthier meat, milk, and eggs.
      </p>
    </div>

  </div>

  <div class="padding-section grid-section">

    <div>
      <h3 class="title">
        Feed
      </h3>
      <p class="description">
        This is a tough one. Firstly, <strong>we want all our animals to primarily consume their natural diet</strong> -
        grass, bugs, acorns, roots, etc. However, some animals need feed supplementation: chickens, pigs, and a small
        amount for the dairy cows (beef cows do not receive grain).
      </p>
      <p class="description">
        While we would love to be able to use <strong>certified organic feed for all our animals</strong>, virtually no
        organic grain is produced in our part of the country, making it a cost-prohibitive scenario. After spending
        considerable time looking for an alternative, we settled on using a locally produced, <strong>non-GMO
          feed</strong>. The highest quality organic mineral supplements and organic anti-parasitic ingredients are
        added to ensure our animals’ optimal health.
      </p>
      <p class="description">
        While we can’t claim that this is organic, it is lightyears better than commercially available feedstuff. Not to
        mention, something can be said for the “localness,” as trucking “organic” feed thousands of miles away doesn’t
        seem “organic.” <strong>We have put a lot of work into the feed we currently use</strong>, though we don’t want
        to become
        satisfied. The feed situation is constantly evolving, and we would caution you not to let perfection be the
        enemy of “very good."
      </p>
    </div>

    <img class="image" loading="lazy" src="/assets/images/landing/about/our-guiding-principles/feed.webp"
      alt="Brown chickens feeding around a container filled with grain on a farm.">

  </div>

  <div class="padding-section pattern grid-section">

    <img class="image" src="/assets/images/landing/about/our-guiding-principles/direct-sales.webp"
      alt="Raw beef cuts arranged on a wooden surface.">

    <div>
      <h3 class="title">
        Direct Sales
      </h3>
      <p class="description">
        The freshest, most nutritious way to purchase food is directly from the farmer. For that reason, we only sell
        from our hands to yours.<strong>This ensures that you always get the freshest, highest-quality food</strong>.
        Because it goes
        out the door with our name, we will ensure it is fresh, nutritious, and delicious. This model also always allows
        you the opportunity to inquire about the food you are purchasing, how it was raised, seasonal variances, etc. We
        believe in total transparency, so any question is fair game. Food just tastes better when you personally know
        the farmer producing it.
      </p>
    </div>

  </div>

</section>
